export default class ValidationError extends Error{
	constructor(field, message=undefined){

		super(message)
		this.name = 'ValidationError'
		this.field = field
		this.message = message
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/error/validation-error.js